import React from "react";
import { Button } from "antd";
import { CrownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { trackFeatureUsage } from "../lib/posthog";

interface AdminMenuProps {
  mobile?: boolean;
}

export const AdminMenu: React.FC<AdminMenuProps> = ({ mobile = false }) => {
  const navigate = useNavigate();

  const handleAdminClick = () => {
    navigate("/admin");
    trackFeatureUsage("admin_dashboard");
  };

  if (mobile) {
    return (
      <div
        key="admin"
        onClick={handleAdminClick}
        style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
      >
        <CrownOutlined style={{ marginRight: 8 }} />
        Admin
      </div>
    );
  }

  return (
    <Button
      type="text"
      icon={<CrownOutlined style={{ fontSize: "18px", color: "#ff9800" }} />}
      className="admin-menu-button"
      onClick={handleAdminClick}
      title="Admin Dashboard"
    />
  );
};
